<nb-tabset (changeTab)="onChangeTab($event)">
  <nb-tab *ngIf="usersRol.CONSULTAR_VISITA" tabTitle="Consultar" tabIcon="search-outline" responsive style="height: 80vh;">
    <app-vins-buques-consulta></app-vins-buques-consulta>
  </nb-tab>
    <nb-tab *ngIf="usersRol.ALTA_VISITA" tabTitle="Alta Visita" tabIcon="upload-outline" responsive style="height: 80vh;">
        <div class="col-md-7" style="float: left;">
          <nb-card>
            <nb-card-body>
              <div class="hundred-per-hor">
                <p-dropdown required class="limited-selector" id="inputBuque" placeholder="Buque"
                  [style]="{'width':'100%','margin-bottom':'10px', 'margin-top':'10px'}" [options]="buquesAlta"
                  [(ngModel)]="buqueAltaSelected" (onChange)="changeBuqueAlta(buqueAltaSelected)" [virtualScroll]="true"
                  [itemSize]="31" [filter]="true" scrollHeight="130px">
                </p-dropdown>
                <span><strong>Linea: </strong></span><span>{{operadorAltaDescSelected}}</span>
              </div>
              <div class="hundred-per-hor"  >
                <mat-form-field  class="labelCodVisita hundred-per-hor">
                <mat-label>Código de visita</mat-label>
                <input [disabled]="!habilitarOperador" matInput #codVisita maxlength="20" [(ngModel)]="codigoVisita" name="codigoVisita"  
                (ngModelChange)="changeCodVistaExt(codigoVisita)">
                </mat-form-field>
              </div>
              <div class="hundred-per-hor">                
                <p-dropdown [disabled]="!habilitarOperador" required class="limited-selector" id="inputOperadores" placeholder="Operador"
                  [style]="{'width':'100%','margin-bottom':'10px', 'margin-top':'10px'}" [options]="operadoresAlta"
                  [(ngModel)]="operadorAltaSelected" (onChange)="changeOperadorAlta(operadorAltaSelected)" [virtualScroll]="true"
                  [itemSize]="31" [filter]="true" scrollHeight="80px">
                </p-dropdown>
              </div>             
              <div class="hundred-per-hor">
                <p-dropdown  [disabled]="!habilitarProceso" required class="limited-selector" id="inputProceso" placeholder="Proceso"
                  [style]="{'width':'100%','margin-bottom':'10px', 'margin-top':'10px'}" [options]="procesosAlta"
                  [(ngModel)]="procesoAltaSelected" (onChange)="changeProcesoAlta(procesoAltaSelected)" [virtualScroll]="true"
                  [itemSize]="31" scrollHeight="80px"
                  >
                </p-dropdown>
              </div>
              <div [hidden]="ocultarFechas" class="hundred-per-hor">
                <mat-form-field [hidden]="procesoAltaSelected == 2" class="fifty-per-hor" style="margin-right: 2%;">
                  <mat-label>Fecha ETA</mat-label>
                  <input matInput [min]="diaTomorrow" [matDatepicker]="pickerFechaAltaETA" disabled (ngModelChange)="changeFechaAltaETA($event)" [(ngModel)]="fechaAltaETA" name="fechaAltaETA">
                  <mat-datepicker-toggle matSuffix [for]="pickerFechaAltaETA">
                  </mat-datepicker-toggle>
                  <mat-datepicker #pickerFechaAltaETA disabled="false"></mat-datepicker>
                </mat-form-field>
                <mat-form-field [hidden]="procesoAltaSelected == 2" class="fifty-per-hor">
                  <mat-label>Fecha ATA</mat-label>
                  <input matInput [min]="diaTomorrow" [matDatepicker]="pickerFechaAltaATA" disabled (ngModelChange)="changeFechaAltaATA($event)" [(ngModel)]="fechaAltaATA" name="fechaAltaATA">
                  <mat-datepicker-toggle matSuffix [for]="pickerFechaAltaATA">
                  </mat-datepicker-toggle>
                  <mat-datepicker #pickerFechaAltaATA disabled="false"></mat-datepicker>
                </mat-form-field>
              </div>
              <div [hidden]="ocultarFechas" class="hundred-per-hor">
                <mat-form-field [hidden]="procesoAltaSelected == 1" class="fifty-per-hor" style="margin-right: 2%;">
                  <mat-label>Fecha ETD</mat-label>
                  <input matInput [min]="diaTomorrow" [matDatepicker]="pickerFechaAltaETD" disabled (ngModelChange)="changeFechaAltaETD($event)" [(ngModel)]="fechaAltaETD" name="fechaAltaETD">
                  <mat-datepicker-toggle matSuffix [for]="pickerFechaAltaETD">
                  </mat-datepicker-toggle>
                  <mat-datepicker #pickerFechaAltaETD disabled="false"></mat-datepicker>
                </mat-form-field>
                <mat-form-field [hidden]="procesoAltaSelected == 1" class="fifty-per-hor">
                  <mat-label>Fecha ATD</mat-label>
                  <input matInput [min]="diaTomorrow" [matDatepicker]="pickerFechaAltaATD" disabled (ngModelChange)="changeFechaAltaATD($event)" [(ngModel)]="fechaAltaATD" name="fechaAltaATD">
                  <mat-datepicker-toggle matSuffix [for]="pickerFechaAltaATD">
                  </mat-datepicker-toggle>
                  <mat-datepicker #pickerFechaAltaATD disabled="false"></mat-datepicker>
                </mat-form-field>
              </div>             
              <div class="hundred-per-hor" style="text-align: -webkit-center;">
                <app-spinner *ngIf="showSpinnerUpload"></app-spinner>
                  <label *ngIf="!showSpinnerUpload" class="file-upload" type="file" 
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" (click)="limpiarArchivo($event)"
                  (change)="addfile($event)" >
                    <input [disabled]="!habilitarUpload" class="invi" type="file"/>
                    <i class="fa fa-cloud-upload"></i> Subir Archivo
                  </label>
                  <p><strong>Archivo: </strong>{{fileName}}</p>
              </div>
            </nb-card-body>
            <nb-card-footer>
              <app-spinner *ngIf="showSpinnerGuardar"></app-spinner>
              <button *ngIf="!showSpinnerGuardar"  [disabled]="!habilitarGuardar" nbButton size="large" status="primary" class="buttontz" style="width: 100%;" (click)="guardarVisita()">Guardar</button>
            </nb-card-footer>
          </nb-card>
        </div>
        <div *ngIf="showGridAlta" class="col-md-5" style="float: right;">
          <!-- <angular-slickgrid gridId="gridVinsAlta"
              [columnDefinitions]="columnDefinitionsVinsAlta"
              [gridOptions]="gridOptionsVinsAlta" 
              [dataset]="dataVinsAlta" 
              gridHeight="460"
              (onAngularGridCreated)="angularGridReadyVinsAlta($event)"
              (sgOnRowCountChanged)="refreshMetrics($event.detail.args)">
            </angular-slickgrid> -->
            <ag-grid-angular
            #grilla1
            class="ag-theme-alpine"
            style="width: 100%; height: 460px;"
            [rowData]="dataVinsAlta"
            [columnDefs]="columnDefinitionsVinsAlta"
            (gridReady)="onGridReady($event)" 
            [enableCellTextSelection]="true"/>
            <span>
              <p><strong>Filtrados: </strong>{{elemFiltered}} <strong>Total: </strong>{{totalReg}}</p>
            </span>
        </div>
    </nb-tab>
    <nb-tab *ngIf="usersRol.MODIFICAR_VISITA" tabTitle="Modificacion" tabIcon="edit-outline" responsive style="height: 80vh;">
        <app-vins-buques-modif></app-vins-buques-modif>
          <!-- <button nbButton shape="round" size="small" class="buttontz float-left" style="margin-bottom: 10px;" (click)="initFrmAlta()">
            <nb-icon nbPrefix icon="refresh-outline"></nb-icon>
          </button> -->
          <!-- <app-spinner *ngIf="showSpinnerConsulta"></app-spinner> -->
    </nb-tab>
</nb-tabset>